import moment from "moment";
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";

export const MobileMonthSelector = ({ date, setDate }) => {
  const [currentDate, setCurrentDate] = useState(moment(date));
  const detailsRef = useRef(null);
  const { i18n } = useTranslation();

  const handleMonthChange = (monthIndex) => {
    const newDate = moment(currentDate).month(monthIndex);
    setDate(newDate);
    detailsRef?.current?.removeAttribute("open");
  };

  return (
    <details ref={detailsRef}>
      <summary>
        <div>
          <span>{moment(date).format("MMMM YYYY")}</span>
          <img src="/img/svg/angle-down.svg" />
        </div>
      </summary>
      <div>
        <div>
          <buton
            onClick={() => {
              setCurrentDate(moment(currentDate).subtract(1, "year"));
            }}
          >
            <img src="/img/new-icons/arrow-left.svg" />
          </buton>
          <span>{moment(currentDate).format("YYYY")}</span>
          <buton
            onClick={() => {
              setCurrentDate(moment(currentDate).add(1, "year"));
            }}
          >
            <img src="/img/new-icons/arrow-right.svg" />
          </buton>
        </div>
        <ul>
          {moment.localeData(i18n.language).months().map((monthName, monthIndex) => {
            const month = moment(currentDate).month(monthIndex);
            const diff = month.diff(moment().startOf("month"), "months");
            const isFutureMonth = diff > 0;
            return (
              <li>
                <button
                  // className={date.month() === monthIndex ? "month-active" : null}
                  key={monthIndex}
                  onClick={() => handleMonthChange(monthIndex)}
                  disabled={isFutureMonth}
                  data-button-type={
                    moment(date).month() === monthIndex
                      ? "primary"
                      : "text-white"
                  }
                >
                  {monthName}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </details>
  );
};
